export const Endpoints = {
    getClientList: '/client/list',
    clientGroupList: '/client/group/list',
    symbolList: '/symbol/list',
    refreshSymbolList: '/symbol/refresh',
    symbolGroupList: '/symbol/group/list',
    filterSymbolList: '/symbol/filterSymbols',
    saveTrading: '/liveTrade',
    liveTradeList: '/liveTrade/list',
    createClient: '/client',
    updateClient: '/client',
    createOrUpdateClientGroup: '/client/group',
    createOrUpdateSymbolGroup: '/symbol/group',
    placeOrder: '/order/placeOrder',
    getHedgeMode: '/positionMode',
    getMarketPrice: '/order/getMarketPrice',
    runCprScan: '/trade/cpr/scan',
    getCprCandles: '/trade/cpr/candle/fetch',
    getApiMetrics: '/metrics/api-rate',
    getLiveLogs: '/logs/stream',
    getLiveMonitor: '/strategy/monitor',
    liveMonitorStream: '/strategy/monitor/stream',
    strategyEventsStream: '/strategy/events/stream',
    strategyEventsHistory: '/strategy/events/history',
}